import React, { useState, useEffect } from "react";
import "./mobileOTP.css";
import OtpInput from "../../../components/Otp/otpinput";
import AxiosInstance from "../../../AxiosInstance";
import Carousels from "../../../components/Slider/index";
import { Modal, Select, message } from "antd";
import UseIsMobile from "../../../feature/ismobilescreen";
import { CarouselList } from "../../../utils/index";
import { useForm } from "react-hook-form";
import ToastNotification from "../../../feature/ToastNotification";
import { useLocation, useNavigate } from "react-router-dom";
import newLogo from "../../../assets/new_logo.png";
import { countryCodeOptions } from "../../../utils/countryCodeOptions";
import { ROLES } from "../../../constants";
import { getIpAddress } from "../../../utils/getIpAddress";

// Static consents shown on UI
const STATIC_CONSENTS = [
  {
    key: "privacy_terms",
    isMandatory: true,
    matchText: "Privacy Policy and Terms",
    message: (
      <>
        I have read, understood, and hereby accept the{" "}
        <a
          href="https://www.thepolicyexchange.com/privacy-policy"
          target="_blank"
          rel="noreferrer"
          style={{ color: "inherit", textDecoration: "underline" }}
        >
          Privacy Policy
        </a>{" "}
        and{" "}
        <a
          href="https://www.thepolicyexchange.com/terms"
          target="_blank"
          rel="noreferrer"
          style={{ color: "inherit", textDecoration: "underline" }}
        >
          Terms & Conditions 
        </a>
        &nbsp;belong to <b>The Policy Exchange</b>
      </>
    ),
  },
  
];

// Fetch from API only to resolve consentIds at submit time
const getLoginConsentsFromApi = async () => {
  try {
    const response = await AxiosInstance().get("/loan-consent/filter", {
      params: { screenName: "login", isActive: true },
    });
    if (response.data?.success) return response.data.data;
    return [];
  } catch (error) {
    console.error("Error fetching login consents:", error);
    return [];
  }
};

// Fetch user's existing consent statuses by mobile
const getUserConsentsByMobile = async (mobileNumber) => {
  try {
    const response = await AxiosInstance().get("/loan-consent/consents-by-mobile", {
      params: { mobileNumber },
    });
    if (response.data?.success) return response.data.data.consents;
    return [];
  } catch (error) {
    console.error("Error fetching user consents by mobile:", error);
    return [];
  }
};

const validation = (event) => {
  const isNumericKey =
    (event.keyCode >= 48 && event.keyCode <= 57) ||
    (event.keyCode >= 96 && event.keyCode <= 105);
  if (
    event.key === "Backspace" ||
    event.keyCode === 8 ||
    isNumericKey ||
    (event.key >= "0" && event.key <= "9")
  ) return true;
  event.preventDefault();
};

const LogoSwitcher = ({ partnerLogoRequired, partnerLogoUrl }) => {
  if (!partnerLogoRequired || !partnerLogoUrl) {
    return (
      <img
        src={newLogo}
        height={100}
        alt="logo-login"
        className="logo-switcher-img"
        style={{ maxWidth: 200, objectFit: "contain" }}
      />
    );
  }
  return (
    <div
      className="logo-switcher-wrapper"
      style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "20px", height: 100, margin: "0 auto" }}
    >
      <img src={newLogo} height={100} alt="logo-login" className="logo-switcher-img" style={{ maxWidth: 150, objectFit: "contain" }} />
      <img src={partnerLogoUrl} height={100} alt="partner-logo" className="logo-switcher-img" style={{ maxWidth: 150, objectFit: "contain" }} />
    </div>
  );
};

const MobileOTP = (props) => {
  const [showConsentMsg, setShowConsentMsg] = useState(false);
  // consentStates keyed by STATIC_CONSENTS key (e.g. "privacy_terms", "communications")
  const [consentStates, setConsentStates] = useState({});
  const [code, setCode] = useState("");
  const handleChange = (code) => setCode(code);
  const { width } = UseIsMobile();
  const [isMobScreen, setMobScreen] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [countryCode, setCountryCode] = useState();
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(10);
  const [partnerLogoRequired, setPartnerLogoRequired] = useState(false);
  const [partnerLogoUrl, setPartnerLogoUrl] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const referralCode = searchParams.get("referralCode");

  const [successStatus, setSuccessStatus] = useState({ sendOtp: false, receiveOtp: false });
  const [tempToken, setTempToken] = useState("");
  const [open, setOpen] = useState(false);
  const [userRoles, setUserRoles] = useState([]);
  const [otpSentMsg, setOtpSentMsg] = useState(true);
  const [isValidInput, setValidInput] = useState(false);
  const navigate = useNavigate();

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({ mode: "onChange" });
  const showModal = () => setOpen(true);

  useEffect(() => {
    const fetchPartnerDetails = async () => {
      const partnerCode = searchParams.get("referralCode");
      if (!partnerCode) return;
      try {
        const resp = await AxiosInstance().post(`/auth/verifyPartnerCode/${partnerCode}`);
        const details = resp?.data;
        if (details?.ParterlogoReqired === true && details?.PartnerLogo) {
          setPartnerLogoRequired(true);
          setPartnerLogoUrl(details.PartnerLogo);
        }
      } catch (err) {
        console.warn("Could not fetch partner details:", err?.response?.data?.message ?? err.message);
      }
    };
    fetchPartnerDetails();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) setSeconds(seconds - 1);
      else if (minutes > 0) { setSeconds(59); setMinutes(minutes - 1); }
      else clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, [seconds, minutes]);

  const setTimer = () => { setMinutes(1); setSeconds(59); };

  // On mobile blur: prefill consent states from user's existing consents
  const handleMobileBlur = async (event) => {
    const mobileValue = event.target.value;
    if (mobileValue && mobileValue.length === 10) {
      const userConsents = await getUserConsentsByMobile(mobileValue);
      // Map API consentId back to static key via matchText
      const apiConsents = await getLoginConsentsFromApi();
      const newStates = {};
      STATIC_CONSENTS.forEach((staticConsent) => {
        const apiMatch = apiConsents.find((c) =>
          c.consentMessage?.includes(staticConsent.matchText)
        );
        if (apiMatch) {
          const userMatch = userConsents.find((uc) => uc.consentId === apiMatch.consentId);
          if (userMatch) newStates[staticConsent.key] = userMatch.consentStatus;
        }
      });
      setConsentStates(newStates);
    }
  };

  const sendOTP = async (value) => {
    setTimer();
    setOtpSentMsg(true);
    setMobileNumber(value.mobileNumber);
    setCountryCode(value.countryCode);
    try {
      const response = await AxiosInstance().post("/auth/sendOtp", {
        phoneNumber: value.mobileNumber,
        countryCode: value.countryCode ?? "+91",
      });
      setSuccessStatus((prev) => ({ ...prev, sendOtp: true }));
      setTempToken(response.data.token);
      message.success({ content: "You will shortly receive OTP on your mobile number", style: { fontSize: "16px", marginTop: "65vh" } });
    } catch (error) {
      message.error(error.response.data.message);
    }
  };

  const resendOTP = async () => {
    try { await sendOTP({ mobileNumber, countryCode }); } catch (error) {}
  };

  // Fetch API consents to get IDs, match with static consents, then submit
  const submitConsentData = async (userData) => {
    try {
      const apiConsents = await getLoginConsentsFromApi();
      
      // Get existing consents for this user
      const existingConsents = await getUserConsentsByMobile(mobileNumber);
      const ipAddress = await getIpAddress();
      for (const staticConsent of STATIC_CONSENTS) {
        const apiMatch = apiConsents.find((c) =>
          c.consentMessage?.includes(staticConsent.matchText)
        );
        
        if (!apiMatch) continue; // skip if no API match
        
        const currentConsentStatus = consentStates[staticConsent.key] || false;
        const existingConsent = existingConsents.find((ec) => ec.consentId === apiMatch.consentId);
        
        if (existingConsent && existingConsent.id) {
          // Update existing record - only send fields that backend expects for update
          console.log("Updating existing consent record:", existingConsent.id);
          console.log("Existing consent data:", existingConsent);
          try {
            await AxiosInstance().put(`/loan-consent/transaction/${existingConsent.id}`, {
              consentStatus: consentStates[staticConsent.key] || false,
              UpdatedBy: userData.user?.id || null,
              ipAddress:ipAddress,
            });
            console.log("Successfully updated consent record");
          } catch (error) {
            console.error("Failed to update consent record:", error.response?.data || error.message);
          }
        } else if (existingConsent && !existingConsent.id) {
          console.log("Existing consent found but ID is undefined, skipping update");
        } else {
          console.log("No existing consent found, will create new record");
          // Create new record
          console.log("Creating new consent record for consentId:", apiMatch.consentId);
          try {
            await AxiosInstance().post("/loan-consent/transaction", {
              consentId: apiMatch.consentId,
              consentStatus: currentConsentStatus,
              isActive: true,
              createdBy: userData.user?.id || null,
              UpdatedBy: null,
              userId: userData.user?.id || null,
              loanId: null,
              policyNumber: null,
              policyId: null,
              mobileNumber: mobileNumber,
              ipAddress:ipAddress
            });
            console.log("Successfully created consent record");
          } catch (error) {
            console.error("Failed to create consent record:", error.response?.data || error.message);
          }
        }
      }
    } catch (error) {
      console.error("Error submitting consent data:", error);
    }
  };

  const onSubmitOtp = async () => {
    if (code.length === 4 && code !== "") {
      try {
        const resp = await AxiosInstance().post("/auth/verifyOtp", { otp: code, token: tempToken });
        const { data } = resp;
        localStorage.clear();
        if (data.isSuccess) {
          localStorage.setItem("token", data.token);
          // sessionStorage.setItem("prodStageSync", data.PROD_STAGE_SYNC);
          await submitConsentData(data);
          if (data.existingUser) {
            const platformRoles = data.userRoles.filter((x) => ROLES.includes(x));
            if (platformRoles.length === 1) redirectToDashboard(platformRoles[0]);
            else if (platformRoles.length > 1) { setUserRoles(platformRoles); showModal(); }
            else {
              localStorage.setItem("data", JSON.stringify(data.user));
              localStorage.setItem("username", `${data.user.firstName} ${data.user.lastName}`);
              navigate("/personaldetails", { state: { referralCode } });
            }
          } else {
            if (!data?.userRoles.length) navigate("/personaldetails", { state: { referralCode } });
          }
        } else setValidInput(true);
      } catch (err) {
        message.error(err.response.data.message);
      }
    } else setValidInput(true);
  };

  useEffect(() => { if (props.isAuthenticated) navigate("/" + location.search); }, []);
  useEffect(() => { setMobScreen(width <= 768); }, [isMobScreen, width]);

  const countryCodeChanged = (value) => setValue("countryCode", value);

  const handleConsentChange = (key, checked) => {
    setConsentStates((prev) => ({ ...prev, [key]: checked }));
  };

  const areMandatoryConsentsAccepted = () =>
    STATIC_CONSENTS.filter((c) => c.isMandatory).every((c) => consentStates[c.key] === true);

  const getAssignmentAppUrl = () => {
    const env = process.env.REACT_APP_ENV;
    return env === "stage"
      ? "https://stage-preowned.thepolicyexchange.com"
      : "https://preowned.thepolicyexchange.com";
  };

  const redirectToDashboard = (role) => {
    if (role === "INVESTOR") {
      AxiosInstance().get("/auth/getNewToken/INVESTOR").then((resp) => {
        if (resp.status === 200) {
          const deeplink = `${getAssignmentAppUrl()}/dev-login?token=${encodeURIComponent(resp.data.token)}`;
          window.location.href = deeplink;
        }
      });
      return;
    }
    const rolesMap = { POLICY_MASTER: "/phdashboard", PARTNER: "/partnerDashboard" };
    if (rolesMap[role]) {
      AxiosInstance().get(`/auth/getNewToken/${role}`).then((resp) => {
        if (resp.status === 200) { localStorage.setItem("token", resp.data.token); window.location.href = rolesMap[role]; }
      });
    }
  };

  return (
    <div className="main-wrapper">
      <div className="website-header">
        <ul className="menu">
          <li className="menuItemOne"><a href="https://thepolicyexchange.com/">Home</a></li>
          <li className="menuItemTwo"><a href="https://www.thepolicyexchange.com/about-us">About Us</a></li>
          <li className="menuItemThree"><a href="https://www.thepolicyexchange.com/faq">FAQ</a></li>
          <hr />
        </ul>
        <div className="d-flex flex-row">
          <div className="align-items-center flex-row mx-5 d-flex d-sm-flex">
            <i className="fa-solid fa-phone header-icon" />
            <div className="d-flex align-items-start flex-column">
              <p className="header-help-heading">Speak with our expert</p>
              <p className="header-help-text">0120-6939400</p>
            </div>
          </div>
          <div className="d-flex align-items-center flex-row d-none d-sm-flex">
            <i className="fa-solid fa-envelope header-icon" />
            <div className="d-flex align-items-start flex-column">
              <p className="header-help-heading">Reach out</p>
              <p className="header-help-text">info@thepolicyexchange.com</p>
            </div>
          </div>
        </div>
      </div>

      <div className="row mobile-view">
        {!isMobScreen && (
          <div className="col-md-7 d-md-flex d-none leftDivOTP">
            <Carousels CarouselList={CarouselList} ClassProps="slik-slider-login" />
          </div>
        )}
        <div
          style={successStatus?.sendOtp ? { paddingTop: "5rem !important" } : {}}
          className="rightDivOTP col-md-offset-1 col-md-4"
        >
          <div className="p-3 w-md-100 tre-login-block text-md-start text-center">
            <div className="text-center w-100 mb-4">
              <LogoSwitcher partnerLogoRequired={partnerLogoRequired} partnerLogoUrl={partnerLogoUrl} />
            </div>
            <h2 className="text-center mainHeading">Welcome!</h2>
            <p className="mainDescription mb-3">Please share your mobile number to proceed further</p>

            <form id="mobileOTP" onSubmit={handleSubmit(sendOTP)}>
              <Modal mask maskClosable={false} open={open} width="600px" title="Choose Your Role" closable={false} footer={null} centered>
                <div className="text-center">
                  {userRoles.includes("POLICY_MASTER") && (
                    <button className="btn btn-primary me-2 mb-2" onClick={() => AxiosInstance().get("/auth/getNewToken/POLICY_MASTER").then((resp) => { if (resp.status === 200) { localStorage.setItem("token", resp.data.token); window.location.href = "/phdashboard"; } })}>Login as Policy Holder</button>
                  )}
                  {userRoles.includes("INVESTOR") && (
                    <button className="btn btn-primary me-2 mb-2" onClick={() => AxiosInstance().get("/auth/getNewToken/INVESTOR").then((resp) => { if (resp.status === 200) { const deeplink = `${getAssignmentAppUrl()}/dev-login?token=${encodeURIComponent(resp.data.token)}`; window.location.href = deeplink; } })}>Login as Investor</button>
                  )}
                  {userRoles.includes("PARTNER") && (
                    <button className="btn btn-primary me-2 mb-2" onClick={() => AxiosInstance().get("/auth/getNewToken/PARTNER").then((resp) => { if (resp.status === 200) { localStorage.setItem("token", resp.data.token); window.location.href = "/partnerDashboard"; } })}>Login as Partner</button>
                  )}
                </div>
              </Modal>

              <div className="tre_flex-vcenter mb-2">
                <label htmlFor="PhoneNumber" className="text-start w-100">Phone Number</label>
              </div>
              <div className={`input-group mb-4 ${isValidInput ? "showError" : "notError"}`}>
                <Select
                  className="countryCode"
                  disabled={successStatus.sendOtp}
                  onChange={countryCodeChanged}
                  size="large"
                  style={{ width: "100%", height: "48px" }}
                  defaultValue={"+91"}
                >
                  {countryCodeOptions()}
                </Select>
                <input
                  id="mobileNumber"
                  type="text"
                  pattern="[0-9]*"
                  autoComplete="off"
                  disabled={successStatus.sendOtp}
                  inputMode="numeric"
                  onKeyDown={validation}
                  className={`form-control mobileField${errors.mobileNumber ? " is-invalid" : ""}`}
                  maxLength={10}
                  aria-label="Text input with dropdown button"
                  {...register("mobileNumber", {
                    required: { value: true, message: "mobile number is required" },
                    onBlur: handleMobileBlur,
                  })}
                />
                {errors?.mobileNumber && <div className="invalid-feedback">{errors.mobileNumber.message}</div>}
              </div>

              {/* ── Static Consents ── */}
              <div className="mb-3">
                {STATIC_CONSENTS.map((consent) => (
                  <div key={consent.key} style={{ marginBottom: "10px" }}>
                    <label style={{ display: "flex", alignItems: "flex-start", gap: "8px", cursor: "pointer", margin: 0 }}>
                      <input
                        type="checkbox"
                        checked={consentStates[consent.key] || false}
                        onChange={(e) => handleConsentChange(consent.key, e.target.checked)}
                        style={{ marginTop: "3px", flexShrink: 0, width: "14px", height: "14px", cursor: "pointer" }}
                      />
                      <span style={{ fontSize: "13px", lineHeight: "1.4", textAlign: "left" }}>
                        {consent.message}
                        {consent.isMandatory && (
                          <span style={{ color: "red", marginLeft: "4px" }}>* (Required)</span>
                        )}
                      </span>
                    </label>
                  </div>
                ))}
              </div>

              <button
                className="normal-button w-100"
                type="submit"
                form="mobileOTP"
                onClick={(e) => {
                  if (!areMandatoryConsentsAccepted()) {
                    e.preventDefault();
                    setShowConsentMsg(true);
                    setTimeout(() => setShowConsentMsg(false), 3000);
                  }
                }}
              >
                Request OTP
              </button>

              {showConsentMsg && (
                <div style={{ marginTop: "10px", fontSize: "14px", color: "red", textAlign: "center" }}>
                  Please agree to the consent terms to proceed.
                </div>
              )}
            </form>
            <br />

            {successStatus.sendOtp && (
              <div className="tre_ptp-block mt-2">
                <div className="d-flex justify-content-center">
                  <label htmlFor="lastName" className="text-center w-100">Enter OTP</label>
                </div>
                <div className="input-container d-flex justify-content-center mt-2 mb-3">
                  <OtpInput autoComplete="off" sendData={handleChange} />
                </div>
                <div className="tre_flex-vcenter d-flex justify-content-center pt-3">
                  <div className="text-gray tre_font-normal">Didn't recieve OTP?</div>
                  <button
                    className="resendotp"
                    disabled={seconds > 0 || minutes > 0}
                    style={{ color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#310BE0" }}
                    onClick={resendOTP}
                  >
                    Resend OTP
                  </button>
                </div>
                {seconds > 0 || minutes > 0 ? (
                  <p className="d-flex justify-content-center mb-3">
                    Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                  </p>
                ) : <p></p>}
                <button className="normal-button w-100" onClick={onSubmitOtp}>Next</button>
                <ToastNotification
                  show={isValidInput}
                  setShow={setValidInput}
                  typeMsg="undefined"
                  notifyMessage={code === "" || code.length < 4 ? "Please Enter OTP" : "Please Enter Current OTP"}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileOTP;